import { ConfigType } from "../utils/requestAPI";

const marketPlaceApis = {
  getAllProductCategories: (): ConfigType => {
    return {
      method: "get",
      url: `/product-categories`,
    };
  },
  addProductCategory: (data: { icon: string; name: string }): ConfigType => {
    return {
      method: "post",
      url: "/product-categories",
      data,
    };
  },
  updateProductCategory: (
    productCategoryId: string,
    data: { icon: string; name: string }
  ): ConfigType => {
    return {
      method: "put",
      url: `/product-categories/${productCategoryId}`,
      data,
    };
  },
  deleteProductCategory: (productCategoryId: string): ConfigType => {
    return {
      method: "delete",
      url: `/product-categories/${productCategoryId}`,
    };
  },
};

export default marketPlaceApis;
